import { $ } from '../shared/dom';
import { sessionStore } from './session-store';
import { hasUnreadDeferred } from './deferred-unread';

/**
 * Sidebar session-list status icons (generating / indexing / delivered
 * deferred answer). Extracted to a leaf so both sessions.ts and
 * session-attachments.ts can use it without a file cycle (ADR-002 phase C).
 */
export function refreshSessionIndicators(): void {
  const list = $('sessions-list');
  if (!list) return;
  list.querySelectorAll('.session-item').forEach((item) => {
    const id = (item as HTMLElement).dataset.id;
    if (!id) return;
    const session = sessionStore.getSession(id);
    const genIcon = item.querySelector('.session-generating-icon');
    const idxIcon = item.querySelector('.session-indexing-icon');
    const defIcon = item.querySelector('.session-deferred-icon');
    const isStreaming = session?.generation.status === 'streaming'
      || sessionStore.isServerGenerating(id);
    const isIndexing = session
      ? session.attachedDocs.some((d) => d.id && (d.status === 'pending' || d.status === 'processing'))
      : false;

    genIcon?.classList.toggle('hidden', !isStreaming);
    idxIcon?.classList.toggle('hidden', !isIndexing || isStreaming);
    defIcon?.classList.toggle('hidden', !hasUnreadDeferred(id));
  });
}
